/** Master list of 70 default words; used to extend a session's word list when the admin picks a larger count. */
export const DEFAULT_WORD_POOL = [
  "Celebration",
  "Chocolate",
  "Cloud",
  "Coffee",
  "Cookie",
  "Cupcake",
  "Dance",
  "Desert",
  "Dinner",
  "Disco",
  "Dog",
  "Dream",
  "Drive",
  "Elephant",
  "Family",
  "Farm",
  "Fireworks",
  "Flower",
  "Forest",
  "Friend",
  "Fun",
  "Game",
  "Garden",
  "Gift",
  "Grass",
  "Guitar",
  "Holiday",
  "Home",
  "Ice Cream",
  "Island",
  "Journey",
  "Kite",
  "Lake",
  "Laugh",
  "Library",
  "Lighthouse",
  "Love",
  "Magic",
  "Market",
  "Meadow",
  "Memories",
  "Moon",
  "Movie",
  "Mountain",
  "Music",
  "Ocean",
  "Painting",
  "Park",
  "Party",
  "Picnic",
  "Playground",
  "Rainbow",
  "Relax",
  "River",
  "Road",
  "Robot",
  "Rocket",
  "Sandcastle",
  "Science",
  "Shopping",
  "Sunshine",
  "Sky",
  "Sleep",
  "Snow",
  "Soccer",
  "Space",
  "Stars",
  "Story",
  "Street",
  "Sunset"
];
